import React, { useEffect, useMemo, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useQzTray } from '../context/QzTrayContext';
import './V9OpsPage.css';

async function parseJsonSafe(res) {
  try {
    return await res.json();
  } catch (_) {
    return null;
  }
}

function V9OpsPage() {
  const { currentUser } = useAuth();
  const { printSticker } = useQzTray() || {};

  const [orderId, setOrderId] = useState('');
  const [orderData, setOrderData] = useState(null);
  const [orderMsg, setOrderMsg] = useState('');

  const [markSku, setMarkSku] = useState('');
  const [pieceId, setPieceId] = useState('');
  const [pieceQty, setPieceQty] = useState('');

  const [packPartner, setPackPartner] = useState('delhivery');
  const [packAwb, setPackAwb] = useState('');

  const [batchQuality, setBatchQuality] = useState('POLY');
  const [batchPreview, setBatchPreview] = useState(null);
  const [batchMsg, setBatchMsg] = useState('');

  const [receiveBatchId, setReceiveBatchId] = useState('');
  const [receiveSku, setReceiveSku] = useState('');
  const [receiveLineId, setReceiveLineId] = useState('');
  const [receiveAllocQty, setReceiveAllocQty] = useState('');
  const [receiveToStockQty, setReceiveToStockQty] = useState('0');

  const [paymentSource, setPaymentSource] = useState('prepaid');
  const [paymentOrderId, setPaymentOrderId] = useState('');
  const [paymentAmount, setPaymentAmount] = useState('');
  const [paymentMsg, setPaymentMsg] = useState('');

  const [queueType, setQueueType] = useState('UNMATCHED_SHIPMENT_EVENTS');
  const [queueRows, setQueueRows] = useState([]);

  const [awbProvider, setAwbProvider] = useState('delhivery');
  const [awbNumber, setAwbNumber] = useState('');
  const [awbExternalStatus, setAwbExternalStatus] = useState('');

  const [cutoverEnabled, setCutoverEnabled] = useState(false);
  const [cutoverTimestamp, setCutoverTimestamp] = useState('');
  const [cutoverTimezone, setCutoverTimezone] = useState('Asia/Kolkata');
  const [cutoverMsg, setCutoverMsg] = useState('');
  const [backfillUntilTimestamp, setBackfillUntilTimestamp] = useState('');
  const [backfillMaxBatches, setBackfillMaxBatches] = useState('4000');
  const [backfillStatusFilter, setBackfillStatusFilter] = useState('ALL');
  const [backfillResetStatuses, setBackfillResetStatuses] = useState(false);
  const [backfillBusy, setBackfillBusy] = useState(false);
  const [backfillMsg, setBackfillMsg] = useState('');
  const [backfillSummary, setBackfillSummary] = useState(null);
  const [backfillRows, setBackfillRows] = useState([]);
  const [shipmentRows, setShipmentRows] = useState([]);
  const [shipmentOptionsByProvider, setShipmentOptionsByProvider] = useState({ delhivery: [], shiprocket: [] });
  const [shipmentDraftSelection, setShipmentDraftSelection] = useState({});
  const [shipmentMsg, setShipmentMsg] = useState('');
  const [newRawStatus, setNewRawStatus] = useState('');
  const [staleRows, setStaleRows] = useState([]);
  const [staleWatchRows, setStaleWatchRows] = useState([]);
  const [staleMsg, setStaleMsg] = useState('');
  const [staleBusy, setStaleBusy] = useState(false);
  const [staleSnoozeHours, setStaleSnoozeHours] = useState({});
  const cloudFnApiBase = 'https://us-central1-fvs-workspace.cloudfunctions.net/app';

  const endpointByPaymentSource = useMemo(() => ({
    cod: '/api/v9/reconcile/payments/cod',
    prepaid: '/api/v9/reconcile/payments/prepaid',
    bank: '/api/v9/reconcile/payments/bank-transfer',
    credit: '/api/v9/reconcile/payments/customer-credit',
  }), []);

  const normalizeRawStatusKey = (value = '') =>
    String(value || '').trim().toLowerCase().replace(/\s+/g, '_');

  const formatRawStatusLabel = (value = '') =>
    String(value || '')
      .trim()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (m) => m.toUpperCase());

  const defaultShipmentRows = [
    { rawStatus: 'created', delhivery: [], shiprocket: [] },
    { rawStatus: 'pending', delhivery: [], shiprocket: [] },
    { rawStatus: 'in_transit', delhivery: ['IN TRANSIT', 'DISPATCHED'], shiprocket: ['IN TRANSIT', 'SHIPPED'] },
    { rawStatus: 'out_for_delivery', delhivery: ['OUT FOR DELIVERY'], shiprocket: ['OUT FOR DELIVERY', 'OFD'] },
    { rawStatus: 'delivered', delhivery: ['DELIVERED'], shiprocket: ['DELIVERED'] },
    { rawStatus: 'rto_in_transit', delhivery: ['RTO IN TRANSIT'], shiprocket: ['RTO IN TRANSIT', 'RTO INITIATED'] },
    { rawStatus: 'rto_delivered', delhivery: ['RTO RECEIVED', 'RTO DELIVERED'], shiprocket: ['RTO DELIVERED'] },
    { rawStatus: 'cancelled', delhivery: [], shiprocket: [] },
    { rawStatus: 'lost', delhivery: [], shiprocket: [] },
    { rawStatus: 'exception', delhivery: [], shiprocket: [] },
    { rawStatus: 'unknown', delhivery: [], shiprocket: [] },
  ];

  const defaultStaleRows = [
    { status: 'ALLOCATING', enabled: true, maxHours: 48, severity: 'warning', suggestedAction: 'review_allocation' },
    { status: 'PRODUCTION', enabled: true, maxHours: 240, severity: 'warning', suggestedAction: 'review_batch_or_po' },
    { status: 'READY_TO_PACK', enabled: true, maxHours: 24, severity: 'warning', suggestedAction: 'pack_or_review_awb' },
    { status: 'PACKED', enabled: true, maxHours: 6, severity: 'critical', suggestedAction: 'refresh_awb_or_check_webhook' },
    { status: 'AWAITING_SHIPMENT_WEBHOOK', enabled: true, maxHours: 6, severity: 'critical', suggestedAction: 'refresh_awb_or_check_webhook' },
    { status: 'IN_TRANSIT', enabled: true, maxHours: 168, severity: 'warning', suggestedAction: 'refresh_awb_or_partner_status' },
    { status: 'RTO_IN_PROGRESS', enabled: true, maxHours: 168, severity: 'warning', suggestedAction: 'review_rto_receipt' },
    { status: 'RTO_RECEIVED', enabled: true, maxHours: 48, severity: 'warning', suggestedAction: 'restock_and_close' },
    { status: 'CUSTOMER_RETURN_IN_PROGRESS', enabled: true, maxHours: 168, severity: 'warning', suggestedAction: 'review_return_receipt' },
    { status: 'RETURN_RECEIVED', enabled: true, maxHours: 48, severity: 'warning', suggestedAction: 'restock_and_close' },
    { status: 'DELIVERED', enabled: true, maxHours: 240, severity: 'info', suggestedAction: 'review_return_window_close' },
  ];

  const authedFetch = async (url, options = {}) => {
    const token = await currentUser.getIdToken();
    return fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        ...(options.headers || {}),
      },
    });
  };

  const loadOrder = async () => {
    if (!orderId.trim()) return;
    setOrderMsg('Loading order...');
    const res = await authedFetch(`/api/v9/orders/${encodeURIComponent(orderId.trim())}`);
    const data = await parseJsonSafe(res);
    if (!res.ok || !data?.ok) {
      setOrderMsg(data?.error?.message || 'Failed to fetch order.');
      return;
    }
    setOrderData(data.result);
    setOrderMsg('Order loaded.');
  };

  const markUsed = async () => {
    if (!orderId || !markSku || !pieceId || !pieceQty) return;
    setOrderMsg('Marking used...');
    const body = {
      items: [
        {
          sku: markSku,
          consume: [{ stockPieceId: pieceId, qty: Number(pieceQty) }],
        },
      ],
    };
    const res = await authedFetch(`/api/v9/orders/${encodeURIComponent(orderId)}/mark-used`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
    const data = await parseJsonSafe(res);
    setOrderMsg(data?.error?.message || 'Mark used completed.');
    const jobs = data?.result?.printJobs || [];
    for (const job of jobs) { printSticker?.(job.payload)?.catch?.(() => {}); }
    await loadOrder();
  };

  const packOrder = async () => {
    if (!orderId || !packAwb) return;
    setOrderMsg('Packing order...');
    const body = {
      shipmentPartner: packPartner,
      awb: packAwb,
      packages: [{ packageRef: `PKG-${Date.now()}`, lineItems: [{ sku: markSku || 'NA', qty: 1 }] }],
    };
    const res = await authedFetch(`/api/v9/orders/${encodeURIComponent(orderId)}/pack`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
    const data = await parseJsonSafe(res);
    setOrderMsg(data?.error?.message || 'Pack updated.');
    await loadOrder();
  };

  const cancelOrder = async () => {
    if (!orderId) return;
    setOrderMsg('Sending cancel request...');
    const res = await authedFetch(`/api/v9/orders/${encodeURIComponent(orderId)}/cancel-request`, {
      method: 'POST',
      body: JSON.stringify({ reason: 'Admin requested cancel' }),
    });
    const data = await parseJsonSafe(res);
    setOrderMsg(data?.error?.message || 'Cancel request processed.');
    await loadOrder();
  };

  const refreshAwb = async () => {
    if (!awbNumber) return;
    setOrderMsg('Refreshing AWB status...');
    const res = await authedFetch('/api/v9/shipments/fetch-awb-status', {
      method: 'POST',
      body: JSON.stringify({
        provider: awbProvider,
        awb: awbNumber,
        externalStatus: awbExternalStatus || undefined,
      }),
    });
    const data = await parseJsonSafe(res);
    setOrderMsg(data?.error?.message || 'AWB refresh completed.');
    if (orderId) await loadOrder();
  };

  const previewBatch = async () => {
    setBatchMsg('Generating batch preview...');
    const res = await authedFetch('/api/v9/production-batches/preview', {
      method: 'POST',
      body: JSON.stringify({ batchQuality }),
    });
    const data = await parseJsonSafe(res);
    if (!res.ok || !data?.ok) {
      setBatchMsg(data?.error?.message || 'Preview failed.');
      return;
    }
    setBatchPreview(data.result);
    setBatchMsg('Batch preview ready.');
  };

  const createBatch = async () => {
    if (!batchPreview?.consolidatedItems?.length) return;
    setBatchMsg('Creating batch...');
    const res = await authedFetch('/api/v9/production-batches', {
      method: 'POST',
      body: JSON.stringify({
        batchQuality: batchPreview.batchQuality,
        consolidatedItems: batchPreview.consolidatedItems,
      }),
    });
    const data = await parseJsonSafe(res);
    setBatchMsg(data?.error?.message || `Batch created: ${data?.result?.batchId || ''}`);
  };

  const receiveBatch = async () => {
    if (!receiveBatchId || !receiveSku || !receiveLineId || !receiveAllocQty) return;
    setBatchMsg('Receiving batch...');
    const res = await authedFetch(`/api/v9/production-batches/${encodeURIComponent(receiveBatchId)}/receive`, {
      method: 'POST',
      body: JSON.stringify({
        receivedItems: [
          {
            sku: receiveSku,
            allocations: [{ orderLineId: receiveLineId, allocatedQuantity: Number(receiveAllocQty) }],
            toStockQuantity: Number(receiveToStockQty || 0),
          },
        ],
      }),
    });
    const data = await parseJsonSafe(res);
    setBatchMsg(data?.error?.message || 'Batch receive done.');
  };

  const reconcilePayment = async () => {
    if (!paymentOrderId || !paymentAmount) return;
    setPaymentMsg('Reconciling payment...');
    const endpoint = endpointByPaymentSource[paymentSource] || endpointByPaymentSource.prepaid;
    const res = await authedFetch(endpoint, {
      method: 'POST',
      body: JSON.stringify({ entries: [{ canonicalOrderId: paymentOrderId, amount: Number(paymentAmount) }] }),
    });
    const data = await parseJsonSafe(res);
    setPaymentMsg(data?.error?.message || 'Payment reconcile completed.');
  };

  const loadQueue = async () => {
    const res = await authedFetch(`/api/v9/ops/queues/${encodeURIComponent(queueType)}?status=OPEN&limit=50`);
    const data = await parseJsonSafe(res);
    if (!res.ok || !data?.ok) return;
    setQueueRows(Array.isArray(data?.result?.items) ? data.result.items : []);
  };

  const loadCutover = async () => {
    setCutoverMsg('Loading cutover config...');
    const res = await authedFetch('/api/v9/admin/cutover');
    const data = await parseJsonSafe(res);
    if (!res.ok || !data?.ok) {
      setCutoverMsg(data?.error?.message || 'Failed to load cutover config.');
      return;
    }
    const cfg = data.result || {};
    setCutoverEnabled(cfg.enabled === true);
    setCutoverTimestamp(cfg.timestamp || '');
    setCutoverTimezone(cfg.timezone || 'Asia/Kolkata');
    setCutoverMsg('Cutover config loaded.');
  };

  const saveCutover = async () => {
    setCutoverMsg('Saving cutover config...');
    const res = await authedFetch('/api/v9/admin/cutover', {
      method: 'POST',
      body: JSON.stringify({
        enabled: cutoverEnabled,
        timestamp: cutoverTimestamp || '',
        timezone: cutoverTimezone || 'Asia/Kolkata',
      }),
    });
    const data = await parseJsonSafe(res);
    if (data?.result?.purgeResult) {
      const p = data.result.purgeResult;
      setCutoverMsg(`Cutover saved. Purged: ${p.deletedOrders} orders, ${p.deletedLines} lines, ${p.deletedQueueDocs} queue docs.`);
    } else {
      setCutoverMsg(data?.error?.message || 'Cutover config saved.');
    }
  };

  const [purgeBusy, setPurgeBusy] = useState(false);
  const runPurgePreCutover = async () => {
    if (!window.confirm('This will permanently delete all V9 orders (+ lines + action queue) created BEFORE the saved cutover timestamp. Proceed?')) return;
    setPurgeBusy(true);
    setCutoverMsg('Purging pre-cutover orders...');
    try {
      const res = await authedFetch('/api/v9/admin/purge-pre-cutover', { method: 'POST' });
      const data = await parseJsonSafe(res);
      if (!res.ok || !data?.ok) {
        setCutoverMsg(data?.error?.message || 'Purge failed.');
        return;
      }
      const r = data.result;
      setCutoverMsg(`Purge complete. Scanned ${r.totalScanned ?? '?'} orders, deleted ${r.deletedOrders} orders, ${r.deletedLines} lines, ${r.deletedQueueDocs} queue docs. (Cutoff: ${r.cutoverTimestamp})`);
    } finally {
      setPurgeBusy(false);
    }
  };

  const applyBackfillSummary = (summary) => {
    const nextSummary = summary && typeof summary === 'object' ? summary : null;
    setBackfillSummary(nextSummary);
    setBackfillRows(Array.isArray(nextSummary?.rows) ? nextSummary.rows : []);
    const suggestedUntil = String(nextSummary?.state?.untilTimestamp || '').trim();
    if (suggestedUntil) {
      setBackfillUntilTimestamp(suggestedUntil);
    }
  };

  const loadBackfillState = async (statusOverride = '', options = {}) => {
    const quiet = options?.quiet === true;
    if (!quiet) setBackfillMsg('Loading batch backfill state...');
    const status = String(statusOverride || backfillStatusFilter || 'ALL').trim().toUpperCase() || 'ALL';
    const res = await authedFetch(`/api/v9/admin/backfill-v2-batches/state?rowLimit=120&status=${encodeURIComponent(status)}`);
    const data = await parseJsonSafe(res);
    if (!res.ok || !data?.ok) {
      if (!quiet) setBackfillMsg(data?.error?.message || 'Failed to load backfill state.');
      return { ok: false, error: data?.error?.message || 'Failed to load backfill state.' };
    }
    applyBackfillSummary(data.result);
    if (!quiet) setBackfillMsg('Backfill state loaded.');
    return { ok: true };
  };

  const prepareBackfillQueue = async () => {
    setBackfillBusy(true);
    setBackfillMsg('Preparing one-by-one backfill queue...');
    try {
      const res = await authedFetch('/api/v9/admin/backfill-v2-batches/prepare', {
        method: 'POST',
        body: JSON.stringify({
          untilTimestamp: backfillUntilTimestamp || '',
          maxBatches: Number(backfillMaxBatches || 4000),
          resetStatuses: backfillResetStatuses,
        }),
      });
      const data = await parseJsonSafe(res);
      if (!res.ok || !data?.ok) {
        setBackfillMsg(data?.error?.message || 'Failed to prepare backfill queue.');
        return;
      }
      applyBackfillSummary(data?.result?.summary || null);
      setBackfillMsg(
        `Queue prepared. scanned=${Number(data?.result?.scanned || 0)}, inserted=${Number(data?.result?.inserted || 0)}, retained=${Number(data?.result?.retained || 0)}.`
      );
    } finally {
      setBackfillBusy(false);
    }
  };

  const backfillNextBatch = async () => {
    setBackfillBusy(true);
    setBackfillMsg('Backfilling next oldest pending batch...');
    try {
      const res = await authedFetch('/api/v9/admin/backfill-v2-batches/next', {
        method: 'POST',
        body: JSON.stringify({}),
      });
      const data = await parseJsonSafe(res);
      if (!res.ok || !data?.ok) {
        setBackfillMsg(data?.error?.message || 'Failed to backfill next batch.');
        return;
      }
      if (data?.result?.done === true) {
        const baseMsg = data?.result?.message || 'No pending batches.';
        setBackfillMsg(baseMsg);
        const refresh = await loadBackfillState(backfillStatusFilter, { quiet: true });
        if (!refresh?.ok) setBackfillMsg(`${baseMsg} (state refresh delayed)`);
        return;
      }
      const processedMsg = `Processed ${String(data?.result?.batchId || '-')}: ${String(data?.result?.status || '').toUpperCase() || 'DONE'} (${Number(data?.result?.elapsedMs || 0)} ms).`;
      setBackfillMsg(processedMsg);
      const refresh = await loadBackfillState(backfillStatusFilter, { quiet: true });
      if (!refresh?.ok) setBackfillMsg(`${processedMsg} (state refresh delayed)`);
    } catch (error) {
      setBackfillMsg(error?.message || 'Failed to backfill next batch.');
    } finally {
      setBackfillBusy(false);
    }
  };

  const loadShipmentMapping = async () => {
    setShipmentMsg('Loading shipment status mapping...');
    let res = await authedFetch('/api/v9/admin/shipment-status-mapping');
    let data = await parseJsonSafe(res);

    // Hosting rewrite fallback (for cases where /api/v9 admin route is temporarily unavailable).
    if (res.status === 404) {
      res = await authedFetch(`${cloudFnApiBase}/api/v9/admin/shipment-status-mapping`);
      data = await parseJsonSafe(res);
    }

    const rowsRaw = (res.ok && data?.ok && Array.isArray(data?.result?.rows)) ? data.result.rows : defaultShipmentRows;
    const rowsNormalized = rowsRaw.map((r) => ({
      rawStatus: normalizeRawStatusKey(r?.rawStatus),
      delhivery: Array.isArray(r?.delhivery) ? r.delhivery.map((x) => String(x || '').trim().toUpperCase()).filter(Boolean) : [],
      shiprocket: Array.isArray(r?.shiprocket) ? r.shiprocket.map((x) => String(x || '').trim().toUpperCase()).filter(Boolean) : [],
    }));
    setShipmentRows(rowsNormalized);

    const options = {
      delhivery: Array.isArray(data?.result?.optionsByProvider?.delhivery)
        ? data.result.optionsByProvider.delhivery.map((x) => String(x || '').trim().toUpperCase()).filter(Boolean)
        : [],
      shiprocket: Array.isArray(data?.result?.optionsByProvider?.shiprocket)
        ? data.result.optionsByProvider.shiprocket.map((x) => String(x || '').trim().toUpperCase()).filter(Boolean)
        : [],
    };

    rowsNormalized.forEach((row) => {
      (Array.isArray(row.delhivery) ? row.delhivery : []).forEach((token) => options.delhivery.push(token));
      (Array.isArray(row.shiprocket) ? row.shiprocket : []).forEach((token) => options.shiprocket.push(token));
    });

    const dedupeSort = (list = []) => Array.from(new Set(list)).sort((a, b) => a.localeCompare(b));
    setShipmentOptionsByProvider({
      delhivery: dedupeSort(options.delhivery),
      shiprocket: dedupeSort(options.shiprocket),
    });
    setShipmentMsg(res.ok && data?.ok ? 'Shipment mapping loaded.' : 'Loaded fallback shipment mapping (API route unavailable).');
  };

  const saveShipmentMapping = async () => {
    if (!shipmentRows.length) {
      setShipmentMsg('Add at least one raw status row.');
      return;
    }
    setShipmentMsg('Saving shipment mapping...');
    const res = await authedFetch('/api/v9/admin/shipment-status-mapping', {
      method: 'POST',
      body: JSON.stringify({ rows: shipmentRows }),
    });
    const data = await parseJsonSafe(res);
    if (!res.ok || !data?.ok) {
      setShipmentMsg(data?.error?.message || 'Failed to save shipment mapping.');
      return;
    }
    setShipmentMsg(`Shipment mapping saved (${Number(data?.result?.rowCount || 0)} rows).`);
    await loadShipmentMapping();
  };

  const addRawStatusRow = () => {
    const key = normalizeRawStatusKey(newRawStatus);
    if (!key) return;
    if (shipmentRows.some((r) => normalizeRawStatusKey(r.rawStatus) === key)) {
      setShipmentMsg(`Raw status "${key}" already exists.`);
      return;
    }
    setShipmentRows((prev) => ([...prev, { rawStatus: key, delhivery: [], shiprocket: [] }]));
    setNewRawStatus('');
    setShipmentMsg('');
  };

  const removeRawStatusRow = (rawStatus) => {
    const key = normalizeRawStatusKey(rawStatus);
    setShipmentRows((prev) => prev.filter((r) => normalizeRawStatusKey(r.rawStatus) !== key));
  };

  const getMappingCellKey = (rawStatus, provider) => `${normalizeRawStatusKey(rawStatus)}__${provider}`;

  const getDraftSelection = (rawStatus, provider) => {
    const key = getMappingCellKey(rawStatus, provider);
    return String(shipmentDraftSelection?.[key] || '').trim().toUpperCase();
  };

  const setDraftSelection = (rawStatus, provider, value) => {
    const key = getMappingCellKey(rawStatus, provider);
    setShipmentDraftSelection((prev) => ({ ...prev, [key]: String(value || '').trim().toUpperCase() }));
  };

  const addProviderSelection = (rawStatus, provider) => {
    const picked = getDraftSelection(rawStatus, provider);
    if (!picked) return;
    const key = normalizeRawStatusKey(rawStatus);
    setShipmentRows((prev) => prev.map((row) => {
      if (normalizeRawStatusKey(row.rawStatus) !== key) return row;
      const list = Array.isArray(row?.[provider]) ? row[provider] : [];
      return { ...row, [provider]: Array.from(new Set([...list, picked])) };
    }));
    setDraftSelection(rawStatus, provider, '');
  };

  const removeProviderSelection = (rawStatus, provider, token) => {
    const key = normalizeRawStatusKey(rawStatus);
    const normToken = String(token || '').trim().toUpperCase();
    setShipmentRows((prev) => prev.map((row) => {
      if (normalizeRawStatusKey(row.rawStatus) !== key) return row;
      const list = Array.isArray(row?.[provider]) ? row[provider] : [];
      return { ...row, [provider]: list.filter((x) => String(x || '').trim().toUpperCase() !== normToken) };
    }));
  };

  const getAvailableOptionsForRow = (provider, rawStatus) => {
    const allOptions = Array.isArray(shipmentOptionsByProvider?.[provider]) ? shipmentOptionsByProvider[provider] : [];
    const key = normalizeRawStatusKey(rawStatus);
    const assignedElsewhere = new Set();
    shipmentRows.forEach((row) => {
      if (normalizeRawStatusKey(row.rawStatus) === key) return;
      const list = Array.isArray(row?.[provider]) ? row[provider] : [];
      list.forEach((token) => assignedElsewhere.add(String(token || '').trim().toUpperCase()));
    });
    const current = shipmentRows.find((r) => normalizeRawStatusKey(r.rawStatus) === key);
    const currentSelected = new Set((Array.isArray(current?.[provider]) ? current[provider] : []).map((x) => String(x || '').trim().toUpperCase()));
    return allOptions.filter((token) => !assignedElsewhere.has(token) && !currentSelected.has(token));
  };

  const normalizeStaleRows = (rows = []) => {
    const sourceRows = Array.isArray(rows) && rows.length ? rows : defaultStaleRows;
    const seen = new Set();
    return sourceRows
      .map((row) => {
        const status = String(row?.status || '').trim().toUpperCase();
        if (!status || seen.has(status)) return null;
        seen.add(status);
        const parsedHours = Number(row?.maxHours);
        return {
          status,
          enabled: row?.enabled !== false,
          maxHours: Number.isFinite(parsedHours) && parsedHours > 0 ? parsedHours : 24,
          severity: ['info', 'warning', 'critical'].includes(String(row?.severity || '').toLowerCase())
            ? String(row.severity).toLowerCase()
            : 'warning',
          suggestedAction: String(row?.suggestedAction || '').trim() || 'review_order',
        };
      })
      .filter(Boolean);
  };

  const loadStaleRules = async ({ quiet = false } = {}) => {
    if (!quiet) setStaleMsg('Loading stale monitor rules...');
    try {
      const res = await authedFetch('/api/v9/admin/stale-status-rules');
      const data = await parseJsonSafe(res);
      const rows = (res.ok && data?.ok && Array.isArray(data?.result?.rows)) ? data.result.rows : defaultStaleRows;
      setStaleRows(normalizeStaleRows(rows));
      if (!quiet) setStaleMsg(res.ok && data?.ok ? 'Stale monitor rules loaded.' : 'Loaded fallback stale monitor rules.');
    } catch (error) {
      setStaleRows(normalizeStaleRows(defaultStaleRows));
      if (!quiet) setStaleMsg(error?.message || 'Failed to load stale monitor rules.');
    }
  };

  const saveStaleRules = async () => {
    const rows = normalizeStaleRows(staleRows);
    if (!rows.length) {
      setStaleMsg('At least one stale monitor rule is required.');
      return;
    }
    setStaleBusy(true);
    setStaleMsg('Saving stale monitor rules...');
    try {
      const res = await authedFetch('/api/v9/admin/stale-status-rules', {
        method: 'POST',
        body: JSON.stringify({ rows }),
      });
      const data = await parseJsonSafe(res);
      if (!res.ok || !data?.ok) {
        setStaleMsg(data?.error?.message || 'Failed to save stale monitor rules.');
        return;
      }
      setStaleRows(normalizeStaleRows(data?.result?.rows || rows));
      setStaleMsg('Stale monitor rules saved.');
    } catch (error) {
      setStaleMsg(error?.message || 'Failed to save stale monitor rules.');
    } finally {
      setStaleBusy(false);
    }
  };

  const loadStaleWatchlist = async ({ quiet = false } = {}) => {
    if (!quiet) setStaleMsg('Loading stale watchlist...');
    try {
      const res = await authedFetch('/api/v9/admin/stale-watchlist?resolved=false&limit=200');
      const data = await parseJsonSafe(res);
      if (!res.ok || !data?.ok) {
        if (!quiet) setStaleMsg(data?.error?.message || 'Failed to load stale watchlist.');
        return;
      }
      setStaleWatchRows(Array.isArray(data?.result?.rows) ? data.result.rows : []);
      if (!quiet) setStaleMsg(`Loaded ${Number(data?.result?.count || 0)} stale watchlist row(s).`);
    } catch (error) {
      if (!quiet) setStaleMsg(error?.message || 'Failed to load stale watchlist.');
    }
  };

  const recomputeStaleWatchlist = async () => {
    setStaleBusy(true);
    setStaleMsg('Running stale monitor...');
    try {
      const res = await authedFetch('/api/v9/admin/stale-watchlist/recompute', {
        method: 'POST',
        body: JSON.stringify({ orderLimit: 5000 }),
      });
      const data = await parseJsonSafe(res);
      if (!res.ok || !data?.ok) {
        setStaleMsg(data?.error?.message || 'Failed to run stale monitor.');
        return;
      }
      const stats = data.result || {};
      await loadStaleWatchlist({ quiet: true });
      setStaleMsg(`Stale monitor completed. Scanned ${Number(stats.scannedOrders || 0)} order(s), open ${Number(stats.staleOpen || 0)}, resolved ${Number(stats.resolved || 0)}.`);
    } catch (error) {
      setStaleMsg(error?.message || 'Failed to run stale monitor.');
    } finally {
      setStaleBusy(false);
    }
  };

  const getStaleWatchId = (row = {}) => String(row.id || `${row.orderId || ''}__${row.status || ''}`).trim();

  const openStaleOrder = (row = {}) => {
    const key = String(row.orderNumber || row.orderId || '').trim();
    if (!key) {
      setStaleMsg('Order number/order id missing for this warning.');
      return;
    }
    window.open(`/v9-orders?searchOrderId=${encodeURIComponent(key)}`, '_blank', 'noopener,noreferrer');
  };

  const refreshStaleAwb = async (row = {}) => {
    const awb = String(row.awb || '').trim();
    const provider = String(row.partner || 'delhivery').trim().toLowerCase();
    if (!awb) {
      setStaleMsg('AWB is not available for this warning.');
      return;
    }
    setStaleBusy(true);
    setStaleMsg(`Refreshing AWB ${awb}...`);
    try {
      const res = await authedFetch('/api/v9/shipments/fetch-awb-status', {
        method: 'POST',
        body: JSON.stringify({ provider, awb }),
      });
      const data = await parseJsonSafe(res);
      if (!res.ok || !data?.ok) {
        setStaleMsg(data?.error?.message || 'Failed to refresh AWB.');
        return;
      }
      await authedFetch(`/api/v9/admin/stale-watchlist/${encodeURIComponent(getStaleWatchId(row))}/recompute`, {
        method: 'POST',
      }).catch(() => null);
      await loadStaleWatchlist({ quiet: true });
      setStaleMsg(`AWB ${awb} refreshed.`);
    } catch (error) {
      setStaleMsg(error?.message || 'Failed to refresh AWB.');
    } finally {
      setStaleBusy(false);
    }
  };

  const markStaleReviewed = async (row = {}) => {
    const watchId = getStaleWatchId(row);
    if (!watchId) return;
    const note = window.prompt('Review note (optional)', row.reviewNote || '') || '';
    setStaleBusy(true);
    setStaleMsg('Marking warning reviewed...');
    try {
      const res = await authedFetch(`/api/v9/admin/stale-watchlist/${encodeURIComponent(watchId)}/review`, {
        method: 'POST',
        body: JSON.stringify({ note }),
      });
      const data = await parseJsonSafe(res);
      if (!res.ok || !data?.ok) {
        setStaleMsg(data?.error?.message || 'Failed to mark warning reviewed.');
        return;
      }
      await loadStaleWatchlist({ quiet: true });
      setStaleMsg('Warning reviewed.');
    } catch (error) {
      setStaleMsg(error?.message || 'Failed to mark warning reviewed.');
    } finally {
      setStaleBusy(false);
    }
  };

  const snoozeStaleWarning = async (row = {}) => {
    const watchId = getStaleWatchId(row);
    if (!watchId) return;
    const hours = Number(staleSnoozeHours[watchId] || 24);
    if (!Number.isFinite(hours) || hours <= 0) {
      setStaleMsg('Snooze hours must be greater than 0.');
      return;
    }
    setStaleBusy(true);
    setStaleMsg(`Snoozing warning for ${hours}h...`);
    try {
      const res = await authedFetch(`/api/v9/admin/stale-watchlist/${encodeURIComponent(watchId)}/snooze`, {
        method: 'POST',
        body: JSON.stringify({ hours }),
      });
      const data = await parseJsonSafe(res);
      if (!res.ok || !data?.ok) {
        setStaleMsg(data?.error?.message || 'Failed to snooze warning.');
        return;
      }
      await loadStaleWatchlist({ quiet: true });
      setStaleMsg(`Warning snoozed for ${hours}h.`);
    } catch (error) {
      setStaleMsg(error?.message || 'Failed to snooze warning.');
    } finally {
      setStaleBusy(false);
    }
  };

  const recomputeStaleOrder = async (row = {}) => {
    const watchId = getStaleWatchId(row);
    if (!watchId) return;
    setStaleBusy(true);
    setStaleMsg('Recomputing this warning...');
    try {
      const res = await authedFetch(`/api/v9/admin/stale-watchlist/${encodeURIComponent(watchId)}/recompute`, {
        method: 'POST',
      });
      const data = await parseJsonSafe(res);
      if (!res.ok || !data?.ok) {
        setStaleMsg(data?.error?.message || 'Failed to recompute warning.');
        return;
      }
      await loadStaleWatchlist({ quiet: true });
      setStaleMsg('Warning recomputed.');
    } catch (error) {
      setStaleMsg(error?.message || 'Failed to recompute warning.');
    } finally {
      setStaleBusy(false);
    }
  };

  const updateStaleRow = (status, patch) => {
    const target = String(status || '').trim().toUpperCase();
    setStaleRows((prev) => normalizeStaleRows(prev).map((row) => (
      row.status === target ? { ...row, ...patch } : row
    )));
  };

  useEffect(() => {
    loadCutover();
    loadBackfillState('ALL');
    loadShipmentMapping();
    loadStaleRules({ quiet: true });
    loadStaleWatchlist({ quiet: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="v9ops-page">
      <header className="v9ops-header">
        <h1>V9 Ops (Admin)</h1>
        <p>Admin-only controls for v9 order flow.</p>
      </header>

      <section className="v9ops-card">
        <h2>V9 Cutover Gate</h2>
        <div className="v9ops-grid">
          <label className="v9ops-inline-check">
            <input type="checkbox" checked={cutoverEnabled} onChange={(e) => setCutoverEnabled(e.target.checked)} />
            <span>Enable v9 cutover gate</span>
          </label>
          <input
            value={cutoverTimestamp}
            onChange={(e) => setCutoverTimestamp(e.target.value)}
            placeholder="Cutover timestamp (ISO, e.g. 2026-03-30T00:00:00+05:30)"
          />
          <input
            value={cutoverTimezone}
            onChange={(e) => setCutoverTimezone(e.target.value)}
            placeholder="Timezone (e.g. Asia/Kolkata)"
          />
          <button onClick={loadCutover}>Load Cutover</button>
          <button onClick={saveCutover}>Save Cutover</button>
          <button
            onClick={runPurgePreCutover}
            disabled={purgeBusy}
            style={{ background: '#c0392b', color: '#fff' }}
          >
            {purgeBusy ? 'Purging…' : '🗑 Purge Pre-Cutover Orders'}
          </button>
        </div>
        <p style={{ fontSize: '0.8rem', color: '#888', marginTop: 4 }}>
          Purge deletes all V9 orders + lines + action queue items created before the saved cutover timestamp.
          Run after changing the cutover date to remove orders that leaked in when the cutoff was earlier.
        </p>
        {cutoverMsg && <div className="v9ops-msg">{cutoverMsg}</div>}
      </section>

      <section className="v9ops-card">
        <h2>V2 Batch Backfill (One By One)</h2>
        <div className="v9ops-grid v9ops-backfill-tools">
          <input
            value={backfillUntilTimestamp}
            onChange={(e) => setBackfillUntilTimestamp(e.target.value)}
            placeholder="Backfill until timestamp (ISO)"
          />
          <input
            value={backfillMaxBatches}
            onChange={(e) => setBackfillMaxBatches(e.target.value)}
            placeholder="Max batches to scan (e.g. 4000)"
            type="number"
            min="1"
            max="10000"
          />
          <select
            value={backfillStatusFilter}
            onChange={(e) => {
              const value = String(e.target.value || 'ALL').trim().toUpperCase();
              setBackfillStatusFilter(value);
              loadBackfillState(value);
            }}
          >
            <option value="ALL">Show All</option>
            <option value="PENDING">Pending</option>
            <option value="DONE">Done</option>
            <option value="SKIPPED">Skipped</option>
            <option value="FAILED">Failed</option>
          </select>
          <label className="v9ops-inline-check">
            <input
              type="checkbox"
              checked={backfillResetStatuses}
              onChange={(e) => setBackfillResetStatuses(e.target.checked)}
            />
            <span>Reset Existing Statuses To Pending</span>
          </label>
          <button onClick={() => loadBackfillState(backfillStatusFilter)} disabled={backfillBusy}>Load State</button>
          <button onClick={prepareBackfillQueue} disabled={backfillBusy}>
            {backfillBusy ? 'Working...' : 'Prepare Queue'}
          </button>
          <button onClick={backfillNextBatch} disabled={backfillBusy}>
            {backfillBusy ? 'Working...' : 'Backfill Next (Oldest)'}
          </button>
        </div>
        {backfillSummary?.totals && (
          <div className="v9ops-backfill-summary">
            <span>Total: {Number(backfillSummary?.totals?.total || 0)}</span>
            <span>Pending: {Number(backfillSummary?.totals?.pending || 0)}</span>
            <span>Done: {Number(backfillSummary?.totals?.done || 0)}</span>
            <span>Skipped: {Number(backfillSummary?.totals?.skipped || 0)}</span>
            <span>Failed: {Number(backfillSummary?.totals?.failed || 0)}</span>
          </div>
        )}
        {backfillSummary?.nextPending?.batchId && (
          <div className="v9ops-msg">
            Next pending: <strong>{backfillSummary.nextPending.batchId}</strong>
            {backfillSummary?.nextPending?.createdAtIso ? ` (${backfillSummary.nextPending.createdAtIso})` : ''}
          </div>
        )}
        <div className="v9ops-table-wrap">
          <table className="v9ops-table">
            <thead>
              <tr>
                <th>Batch ID</th>
                <th>Created</th>
                <th>Status</th>
                <th>Attempts</th>
                <th>Orders</th>
                <th>Links</th>
                <th>Note</th>
              </tr>
            </thead>
            <tbody>
              {backfillRows.map((row) => (
                <tr key={row.id || row.batchId}>
                  <td>{row.batchId || '-'}</td>
                  <td>{row.createdAtIso || '-'}</td>
                  <td>{row.status || '-'}</td>
                  <td>{Number(row.attempts || 0)}</td>
                  <td>{Number(row.touchedOrders || 0)}</td>
                  <td>{Number(row.linksUpserted || 0)}</td>
                  <td>{row.errorMessage || row.skipReason || '-'}</td>
                </tr>
              ))}
              {backfillRows.length === 0 && (
                <tr>
                  <td colSpan="7">No rows in backfill state.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {backfillMsg && <div className="v9ops-msg">{backfillMsg}</div>}
      </section>

      <section className="v9ops-card">
        <h2>Shipment Status Mapping (V9)</h2>
        <div className="v9ops-grid v9ops-shipment-tools">
          <input
            value={newRawStatus}
            onChange={(e) => setNewRawStatus(e.target.value)}
            placeholder="Add raw status key (e.g. lost, out_for_delivery)"
          />
          <button onClick={addRawStatusRow}>Add Raw Status</button>
          <button onClick={loadShipmentMapping}>Reload Mapping</button>
          <button onClick={saveShipmentMapping}>Save Mapping</button>
        </div>
        <div className="v9ops-table-wrap">
          <table className="v9ops-table">
            <thead>
              <tr>
                <th>Raw Status</th>
                <th>Delhivery</th>
                <th>Shiprocket</th>
              </tr>
            </thead>
            <tbody>
              {shipmentRows.map((row) => {
                const key = normalizeRawStatusKey(row.rawStatus);
                const delhiveryOptions = getAvailableOptionsForRow('delhivery', key);
                const shiprocketOptions = getAvailableOptionsForRow('shiprocket', key);
                return (
                  <tr key={key}>
                    <td>
                      <div className="v9ops-raw-label">{formatRawStatusLabel(row.rawStatus)}</div>
                      <div className="v9ops-raw-key">{row.rawStatus}</div>
                      <button className="v9ops-mini-danger" onClick={() => removeRawStatusRow(row.rawStatus)}>Remove</button>
                    </td>
                    <td>
                      <div className="v9ops-map-cell">
                        <div className="v9ops-chip-wrap">
                          {(Array.isArray(row.delhivery) ? row.delhivery : []).map((token) => (
                            <span key={`${key}-d-chip-${token}`} className="v9ops-chip">
                              {token}
                              <button type="button" onClick={() => removeProviderSelection(row.rawStatus, 'delhivery', token)}>x</button>
                            </span>
                          ))}
                          {(!Array.isArray(row.delhivery) || row.delhivery.length === 0) && (
                            <span className="v9ops-chip-empty">No status selected</span>
                          )}
                        </div>
                        <div className="v9ops-cell-actions">
                          <select
                            value={getDraftSelection(row.rawStatus, 'delhivery')}
                            onChange={(e) => setDraftSelection(row.rawStatus, 'delhivery', e.target.value)}
                          >
                            <option value="">Select status</option>
                            {delhiveryOptions.map((opt) => (
                              <option key={`${key}-d-${opt}`} value={opt}>{opt}</option>
                            ))}
                          </select>
                          <button
                            type="button"
                            onClick={() => addProviderSelection(row.rawStatus, 'delhivery')}
                            disabled={!getDraftSelection(row.rawStatus, 'delhivery')}
                          >
                            Add
                          </button>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="v9ops-map-cell">
                        <div className="v9ops-chip-wrap">
                          {(Array.isArray(row.shiprocket) ? row.shiprocket : []).map((token) => (
                            <span key={`${key}-s-chip-${token}`} className="v9ops-chip">
                              {token}
                              <button type="button" onClick={() => removeProviderSelection(row.rawStatus, 'shiprocket', token)}>x</button>
                            </span>
                          ))}
                          {(!Array.isArray(row.shiprocket) || row.shiprocket.length === 0) && (
                            <span className="v9ops-chip-empty">No status selected</span>
                          )}
                        </div>
                        <div className="v9ops-cell-actions">
                          <select
                            value={getDraftSelection(row.rawStatus, 'shiprocket')}
                            onChange={(e) => setDraftSelection(row.rawStatus, 'shiprocket', e.target.value)}
                          >
                            <option value="">Select status</option>
                            {shiprocketOptions.map((opt) => (
                              <option key={`${key}-s-${opt}`} value={opt}>{opt}</option>
                            ))}
                          </select>
                          <button
                            type="button"
                            onClick={() => addProviderSelection(row.rawStatus, 'shiprocket')}
                            disabled={!getDraftSelection(row.rawStatus, 'shiprocket')}
                          >
                            Add
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })}
              {shipmentRows.length === 0 && (
                <tr>
                  <td colSpan="3">No raw status rows yet.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {shipmentMsg && <div className="v9ops-msg">{shipmentMsg}</div>}
      </section>

      <section className="v9ops-card">
        <h2>Stale Order Monitor (V9)</h2>
        <div className="v9ops-grid v9ops-stale-tools">
          <button onClick={loadStaleRules} disabled={staleBusy}>Reload Rules</button>
          <button onClick={saveStaleRules} disabled={staleBusy}>Save Rules</button>
          <button onClick={recomputeStaleWatchlist} disabled={staleBusy}>
            {staleBusy ? 'Working...' : 'Run Monitor'}
          </button>
          <button onClick={loadStaleWatchlist} disabled={staleBusy}>Reload Watchlist</button>
        </div>
        <div className="v9ops-table-wrap">
          <table className="v9ops-table">
            <thead>
              <tr>
                <th>Enabled</th>
                <th>Status</th>
                <th>Max Hours</th>
                <th>Severity</th>
                <th>Suggested Action</th>
              </tr>
            </thead>
            <tbody>
              {normalizeStaleRows(staleRows).map((row) => (
                <tr key={row.status}>
                  <td>
                    <input
                      type="checkbox"
                      checked={row.enabled !== false}
                      onChange={(e) => updateStaleRow(row.status, { enabled: e.target.checked })}
                    />
                  </td>
                  <td>
                    <strong>{row.status}</strong>
                  </td>
                  <td>
                    <input
                      className="v9ops-number-input"
                      type="number"
                      min="1"
                      max="8760"
                      step="1"
                      value={row.maxHours}
                      onChange={(e) => updateStaleRow(row.status, { maxHours: e.target.value })}
                    />
                  </td>
                  <td>
                    <select
                      className="v9ops-compact-select"
                      value={row.severity}
                      onChange={(e) => updateStaleRow(row.status, { severity: e.target.value })}
                    >
                      <option value="info">Info</option>
                      <option value="warning">Warning</option>
                      <option value="critical">Critical</option>
                    </select>
                  </td>
                  <td>
                    <input
                      className="v9ops-wide-input"
                      value={row.suggestedAction}
                      onChange={(e) => updateStaleRow(row.status, { suggestedAction: e.target.value })}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="v9ops-subtitle">Open Watchlist</div>
        <div className="v9ops-table-wrap">
          <table className="v9ops-table">
            <thead>
              <tr>
                <th>Order</th>
                <th>Status</th>
                <th>Age</th>
                <th>Max</th>
                <th>Severity</th>
                <th>Anchor</th>
                <th>Suggested</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {staleWatchRows.map((row) => {
                const watchId = getStaleWatchId(row);
                const awb = String(row.awb || '').trim();
                return (
                  <tr key={watchId || `${row.orderId}-${row.status}`}>
                    <td>
                      <div><strong>{row.orderNumber || row.orderId || '-'}</strong></div>
                      <div className="v9ops-raw-key">{row.orderId || '-'}</div>
                      {row.source && <div className="v9ops-raw-key">Source: {row.source}</div>}
                    </td>
                    <td>{row.status || row.orderStatus || '-'}</td>
                    <td>{Number(row.ageHours || 0).toFixed(1)}h</td>
                    <td>{Number(row.maxHours || 0)}h</td>
                    <td>
                      <span className={`v9ops-severity v9ops-severity-${String(row.severity || 'warning').toLowerCase()}`}>
                        {row.severity || 'warning'}
                      </span>
                    </td>
                    <td>{row.anchorAt || '-'}</td>
                    <td>
                      <div>{row.suggestedAction || '-'}</div>
                      {awb && <div className="v9ops-raw-key">AWB: {awb}</div>}
                      {row.reviewed && <div className="v9ops-raw-key">Reviewed: {row.reviewedBy || row.reviewedAt || 'yes'}</div>}
                    </td>
                    <td>
                      <div className="v9ops-row-actions">
                        <button type="button" onClick={() => openStaleOrder(row)}>Open</button>
                        <button type="button" disabled={!awb || staleBusy} onClick={() => refreshStaleAwb(row)}>Refresh AWB</button>
                        <button type="button" disabled={staleBusy} onClick={() => markStaleReviewed(row)}>Review</button>
                        <div className="v9ops-snooze-action">
                          <input
                            type="number"
                            min="1"
                            max="720"
                            value={staleSnoozeHours[watchId] || 24}
                            onChange={(e) => setStaleSnoozeHours((prev) => ({ ...prev, [watchId]: e.target.value }))}
                          />
                          <button type="button" disabled={staleBusy} onClick={() => snoozeStaleWarning(row)}>Snooze h</button>
                        </div>
                        <button type="button" disabled={staleBusy} onClick={() => recomputeStaleOrder(row)}>Recompute</button>
                      </div>
                    </td>
                  </tr>
                );
              })}
              {staleWatchRows.length === 0 && (
                <tr>
                  <td colSpan="8">No stale orders currently in watchlist.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {staleMsg && <div className="v9ops-msg">{staleMsg}</div>}
      </section>

      <section className="v9ops-card">
        <h2>Order Controls</h2>
        <div className="v9ops-grid">
          <input value={orderId} onChange={(e) => setOrderId(e.target.value)} placeholder="Canonical Order ID (ORDV9-...)" />
          <button onClick={loadOrder}>Load Order</button>
          <input value={markSku} onChange={(e) => setMarkSku(e.target.value)} placeholder="SKU" />
          <input value={pieceId} onChange={(e) => setPieceId(e.target.value)} placeholder="Stock Piece ID" />
          <input value={pieceQty} onChange={(e) => setPieceQty(e.target.value)} placeholder="Qty" type="number" step="0.01" />
          <button onClick={markUsed}>Mark Used</button>
          <select value={packPartner} onChange={(e) => setPackPartner(e.target.value)}>
            <option value="delhivery">Delhivery</option>
            <option value="shiprocket">Shiprocket</option>
          </select>
          <input value={packAwb} onChange={(e) => setPackAwb(e.target.value)} placeholder="AWB" />
          <button onClick={packOrder}>Pack</button>
          <button onClick={cancelOrder}>Cancel Request</button>
        </div>
        <div className="v9ops-subtitle">Manual AWB Refresh</div>
        <div className="v9ops-grid">
          <select value={awbProvider} onChange={(e) => setAwbProvider(e.target.value)}>
            <option value="delhivery">Delhivery</option>
            <option value="shiprocket">Shiprocket</option>
          </select>
          <input value={awbNumber} onChange={(e) => setAwbNumber(e.target.value)} placeholder="AWB Number" />
          <input value={awbExternalStatus} onChange={(e) => setAwbExternalStatus(e.target.value)} placeholder="External Status (optional)" />
          <button onClick={refreshAwb}>Fetch Latest AWB Status</button>
        </div>
        {orderMsg && <div className="v9ops-msg">{orderMsg}</div>}
        {orderData && <pre className="v9ops-json">{JSON.stringify(orderData, null, 2)}</pre>}
      </section>

      <section className="v9ops-card">
        <h2>Production (V9)</h2>
        <div className="v9ops-grid">
          <input value={batchQuality} onChange={(e) => setBatchQuality(e.target.value)} placeholder="Batch Quality" />
          <button onClick={previewBatch}>Preview Batch</button>
          <button onClick={createBatch}>Create Batch From Preview</button>
        </div>
        <div className="v9ops-grid">
          <input value={receiveBatchId} onChange={(e) => setReceiveBatchId(e.target.value)} placeholder="Batch ID" />
          <input value={receiveSku} onChange={(e) => setReceiveSku(e.target.value)} placeholder="SKU" />
          <input value={receiveLineId} onChange={(e) => setReceiveLineId(e.target.value)} placeholder="Order Line ID" />
          <input value={receiveAllocQty} onChange={(e) => setReceiveAllocQty(e.target.value)} placeholder="Allocated Qty" type="number" step="0.01" />
          <input value={receiveToStockQty} onChange={(e) => setReceiveToStockQty(e.target.value)} placeholder="To Stock Qty" type="number" step="0.01" />
          <button onClick={receiveBatch}>Receive Batch</button>
        </div>
        {batchMsg && <div className="v9ops-msg">{batchMsg}</div>}
        {batchPreview && <pre className="v9ops-json">{JSON.stringify(batchPreview, null, 2)}</pre>}
      </section>

      <section className="v9ops-card">
        <h2>Payments (V9)</h2>
        <div className="v9ops-grid">
          <select value={paymentSource} onChange={(e) => setPaymentSource(e.target.value)}>
            <option value="cod">COD (delivery partner)</option>
            <option value="prepaid">Prepaid (Razorpay)</option>
            <option value="bank">Bank Transfer</option>
            <option value="credit">Customer Credit</option>
          </select>
          <input value={paymentOrderId} onChange={(e) => setPaymentOrderId(e.target.value)} placeholder="Order ID" />
          <input value={paymentAmount} onChange={(e) => setPaymentAmount(e.target.value)} placeholder="Amount" type="number" step="0.01" />
          <button onClick={reconcilePayment}>Reconcile</button>
        </div>
        {paymentMsg && <div className="v9ops-msg">{paymentMsg}</div>}
      </section>

      <section className="v9ops-card">
        <h2>Ops Queue</h2>
        <div className="v9ops-grid">
          <select value={queueType} onChange={(e) => setQueueType(e.target.value)}>
            <option value="UNMATCHED_SHIPMENT_EVENTS">Unmatched Shipment</option>
            <option value="POSSIBLE_DUPLICATE_REVIEW">Possible Duplicate Review</option>
            <option value="SOURCE_REMOVAL_DECISION">Source Removal Decision</option>
            <option value="PAYMENT_RECONCILE_HOLD">Payment Reconcile Hold</option>
            <option value="BACKWARD_STATUS_REVIEW">Backward Status Review</option>
          </select>
          <button onClick={loadQueue}>Load Queue</button>
        </div>
        <pre className="v9ops-json">{JSON.stringify(queueRows, null, 2)}</pre>
      </section>
    </div>
  );
}

export default V9OpsPage;
